import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const GlobalStatusCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  width: 100%;
  margin-bottom: ${Spacing.S16};
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey100};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
`

export const LoadingWrapper = styled.div`
  margin-bottom: ${Spacing.S16};
`

interface IconTileProps {
  isSuccess: boolean
}

export const IconTile = styled('div', {
  shouldForwardProp: (propName) => propName !== 'isSuccess',
})<IconTileProps>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BorderRadius.R12};
  background: ${({ isSuccess }) =>
    isSuccess ? Color.Green100 : `linear-gradient(135deg, ${Color.Purple50} 0%, ${Color.Lavender100} 100%)`};
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S4};
  min-width: 0;
`
